import * as Yup from 'yup';

// Matches legacy's AddressParties.js validation exactly: PartyRelationship is always required,
// and either Person or Place is required depending on which PartyType is selected.
const addressPartySchema = Yup.object({
  PartyType: Yup.string().nullable().required(),
  PartyRelationship: Yup.string().nullable().required('Relationship is required'),
  ptsPartyID: Yup.number()
    .nullable()
    .when('PartyType', {
      is: 'Person',
      then: (schema) => schema.required('Person is required'),
    })
    .when('PartyType', {
      is: 'Place',
      then: (schema) => schema.required('Place is required'),
    }),
  PriorityOrder: Yup.number().nullable(),
  AdvisoryText: Yup.string().nullable(),
});

export default addressPartySchema;
